import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { ListasSeleccion } from '@/modules/ReservasTemp/interfaces/ListasSeleccion'

interface MonedaState {
  moneda: ListasSeleccion | null
  listaMonedas: ListasSeleccion[]
}

const initialState: MonedaState = {
  moneda: { ListaSeleccionId: 0, Nombre: 'USD', Valor: '' },
  listaMonedas: [] as ListasSeleccion[],
}

const monedaSlice = createSlice({
  name: 'moneda',
  initialState,
  reducers: {
    setMoneda: (state, action: PayloadAction<{ moneda: ListasSeleccion }>) => {
      state.moneda = action.payload.moneda
    },
    setListaMonedas: (state, action: PayloadAction<{ listaMonedas: ListasSeleccion[] }>) => {
      state.listaMonedas = action.payload.listaMonedas
    },
  },
})

export const { setMoneda, setListaMonedas } = monedaSlice.actions

const MonedaReducer = monedaSlice.reducer

export default MonedaReducer
